// 公共方法
export const publicFun = {
    gettimestamp(){
        return new Date().getTime();
    },
    // 时间戳转换 年-月-日 时:分:秒
    timestampToTime(timestamp) {
      if(timestamp == "undefined" || timestamp == null || timestamp == ""){
        return ""
      }
        var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        var m =
          (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
          ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
    },
    // 年-月-日 转换时间戳(毫秒)
    //type 1开始时间 2结束时间
    timeToTimestamp(time,type) {
      if(time == "undefined" || time == null || time == ""){
          return ""
      }
      if(type == 1){
        time = time + " " +"00:00:00"
      }else{
        time = time + " " +"23:59:59"
      }
      var date = new Date(time);
      var timestamp = date.getTime();
      return timestamp;
  },
  // 剩余天数
  getRemainingNumberDays(time){
    if (time == 0) {
      return "";
    }
    var remainingCount = time - new Date().getTime(); //时间差的毫秒数
    var dataStr = 0;
    if (remainingCount > 0) {
      var num = remainingCount / (24 * 3600 * 1000);
      if (num > 1) {
        dataStr = Math.floor(remainingCount / (24 * 3600 * 1000));
      } else {
        dataStr = 1;
      }
      dataStr += "天"
    } else {
      dataStr = "已结束";
    }
    return dataStr;
  },
}